import styled from 'styled-components';

import { theme } from '../../theme';

export const SemiBold = styled.span`
	font-family: ${theme.typography.fonts.semibold};
`;
